import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { getDeviceBreakdown } from '../../../services/eventAnalyticsService';

const BehaviorBreakdown = () => {
  const { devices, browsers } = getDeviceBreakdown();

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="mb-5">
        <h3 className="text-base font-semibold text-foreground">User Behavior Breakdown</h3>
        <p className="text-xs text-muted-foreground mt-0.5">Device & browser distribution</p>
      </div>
      <div className="flex items-center gap-6">
        {/* Donut chart */}
        <div className="flex-shrink-0">
          <ResponsiveContainer width={120} height={120}>
            <PieChart>
              <Pie
                data={devices}
                cx="50%"
                cy="50%"
                innerRadius={36}
                outerRadius={56}
                paddingAngle={3}
                dataKey="value"
              >
                {devices?.map((entry, idx) => (
                  <Cell key={idx} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(val) => [`${val}%`, '']}
                contentStyle={{ fontSize: 11, borderRadius: 8, border: '1px solid var(--color-border)', background: 'var(--color-card)' }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        {/* Device legend */}
        <div className="flex-1 space-y-2">
          {devices?.map((d) => (
            <div key={d?.name} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: d?.color }} />
                <span className="text-xs text-muted-foreground">{d?.name}</span>
              </div>
              <span className="text-xs font-semibold text-foreground">{d?.value}%</span>
            </div>
          ))}
        </div>
      </div>
      {/* Browser bars */}
      <div className="mt-5 pt-4 border-t border-border space-y-2">
        <p className="text-xs text-muted-foreground font-medium mb-3">Browser Share</p>
        {browsers?.map((b) => (
          <div key={b?.name} className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground w-14 flex-shrink-0">{b?.name}</span>
            <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full rounded-full bg-primary"
                style={{ width: `${b?.value}%`, opacity: 0.6 + b?.value / 200 }}
              />
            </div>
            <span className="text-xs text-foreground font-medium w-8 text-right">{b?.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BehaviorBreakdown;
